/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { MenuView } from '../../../types/MenuView';

const useHideIconsOnMobile = (elemId: string, scrolledClass: string) => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isMobile = useSelector(select.device.isMobile);
  const menuView = useSelector(select.cms.getMenuView);

  const handleScroll = () => {
    const header = document.getElementById('CMSheader');
    const container = document.getElementById(elemId);

    if (!header || !container || menuView !== MenuView.iconsAndText) {
      return;
    }

    const headerHeight = header.clientHeight;
    const { scrollY } = window;

    if (scrollY > headerHeight - 30) {
      !container.classList.contains(scrolledClass) && container.classList.add(scrolledClass);
    } else {
      container.classList.remove(scrolledClass);
    }
  };

  useEffect(() => {
    if (!isDesktopEmbedded && !isMobile) return;

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isDesktopEmbedded, isMobile]);
};

export default useHideIconsOnMobile;
